import React from 'react';
import JourneySlider from "../Package/IframeComponent"; 


function Journey() {
    return (
        <>
            {/* #journey */}
            <section className="journey section" id="journey" aria-label="journey">
                <div className="container" style={{ marginTop: '15px' }}>
                    <div className="container">
                        <h2 className="headline headline-2 section-title" style={{ fontSize: '4.5rem' }}>
                            <span className="span">My Journey</span>
                        </h2>
                        <p className="section-text">
                            Prabhjeet Singh's journey encompasses a range of roles, from capturing life's moments as a Cinematographer
                            to crafting
                            digital experiences as a Web Application Developer. He exudes style as a Lifestyle Influencer, while his
                            entrepreneurial
                            drive shines as the Founder &amp; CEO of PS Creative Media. Prabhjeet's path showcases creativity, tech
                            expertise, and a dynamic entrepreneurial spirit.
                        </p>
                    </div>
                    <JourneySlider />
                </div>
            </section>

        </>
    )
}

export default Journey